import { render, staticRenderFns } from "./lookup.vue?vue&type=template&id=ed504cfe&"
import script from "./lookup.vue?vue&type=script&lang=js&"
export * from "./lookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports